import React from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import LoginSignup from "../Authentication/LoginSignup";
import { textBoxConstants } from "../../constants";
import PowerBox from "../NewLanding/PowerBox";
import CalendyForm from "../MarketingLandingPage/CalendyForm";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

function MarketPlacePower({ history }) {
  // Render TextBoxes
  const renderTextBoxes = () => {
    let reverse = false;
    return (
      <div>
        {textBoxConstants.map((textBox) => {
          reverse = !reverse;
          // console.log(reverse);
          if (textBox.header === "Power of the Mobile360 Marketplace")
            return (
              <PowerBox
                header={textBox.header}
                text={textBox.text}
                bullets={textBox.bullets}
                imgSrc={textBox.imgSrc}
                reverse={reverse}
                key={textBox.header}
              ></PowerBox>
            );
        })}
      </div>
    );
  };

  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <main
          style={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: "rgb(255, 255, 255)",
            flex: "1 0 auto",
            textAlign: "center",
          }}
        >
          {renderTextBoxes()}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <LoginSignup
              buttonText="Get Started Now"
              fontWeight="bold"
              fontSize="20px"
            />
          </div>
          <div className={styles.row}>
            {/************************************************************************************************
             *************************************************************************************************
             * Schedule a Demo Row
             * This row is for Calendy Demo scheduling
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1}>
                <styles.H2
                  style={{
                    textAlign: "center",
                    width: "100%",
                    marginBottom: "30px",
                  }}
                >
                  Schedule a Free 30 Minute{" "}
                  <span className={styles.styledUnderline}>Demo</span>
                </styles.H2>

                <br></br>
                <CalendyForm />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default MarketPlacePower;
